export const ORDER_APPLICATION_CONFIRM_MESSAGE_BY_ACTION = {
	return_state: "¿Está seguro de que desea volver un estado atrás la orden de aplicación seleccionada?",
	approve: "¿Está seguro de que desea aprobar la orden de aplicación seleccionada?",
	reject: "¿Está seguro de que desea rechazar la orden de aplicación seleccionada?",
	delete: "¿Está seguro de que desea eliminar la orden de aplicación seleccionada?",
	finish: "¿Está seguro de que desea finalizar la orden de aplicación seleccionada?",
	duplicate: (orderCode) => `¿Deseas duplicar la orden ${orderCode}?`,
};
